<template>
  <el-form
    ref="ruleForm"
    :model="item"
    label-position="left"
    label-width="160px"
  >
    <el-tabs v-model="tab" type="card" tab-position="top">
      <el-tab-pane
        v-for="key in ['top', 'left', 'right', 'bottom']"
        :key="key"
        :label="_.startCase(key)"
        :name="key"
      >
        <el-form-item
          label="Landing Page"
          :prop="`${key}.landing_page`"
          :rules="urlRule('landing_page')"
          ><el-input v-model="item[key].landing_page"></el-input
        ></el-form-item>
        <el-form-item
          label="Click Tracking URL"
          :prop="`${key}.click_tracking`"
          :rules="urlRule('click_tracking', false)"
          ><el-input v-model="item[key].click_tracking"></el-input
        ></el-form-item>

        <form-item-group
          title="Images"
          :min="CONSTANT.CREATIVE_DEFAULT_VALUE.SPINNER.IMAGE.MIN_NUM"
          :max="CONSTANT.CREATIVE_DEFAULT_VALUE.SPINNER.IMAGE.MAX_NUM"
          :group-item="CONSTANT.CREATIVE_DEFAULT_VALUE.SPINNER.IMAGE.ITEM"
          v-model="item[key].images"
        >
          <template slot-scope="{ index }">
            <el-row type="flex" justify="space-between" :gutter="10">
              <el-col :span="18">
                <el-form-item
                  label="Image"
                  :prop="`${key}.images.${index}.url`"
                  :rules="[
                    ...imageSizeRule(limited_size.image),
                    ...urlRule('image_url'),
                  ]"
                  label-width="80px"
                >
                  <file-input
                    accept="image/jpeg, image/png, image/gif"
                    v-model="item[key].images[index].url"
                    :check_upload_image_size="{
                      ...limited_size.image,
                      enable: true,
                    }"
                  ></file-input>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-checkbox v-model="item[key].images[index].use_shake_center"
                  >Shake Center</el-checkbox
                >
              </el-col>
            </el-row>
            <el-form-item
              v-for="axis in ['x', 'y']"
              :key="axis"
              :label="_.startCase(axis) + ' Axis'"
              label-width="70px"
              :prop="`${key}.images.${index}.shake_center.${axis}`"
            >
              <el-slider
                v-model="item[key].images[index].shake_center[axis]"
                show-input
                input-size="mini"
                :disabled="!item[key].images[index].use_shake_center"
              ></el-slider>
            </el-form-item>
          </template>
        </form-item-group>
      </el-tab-pane>
    </el-tabs>
    <el-divider> </el-divider>
    <el-form-item label="Bottom Offset" label-width="120px">
      <Offset v-model="item.offset_bottom"> </Offset>
    </el-form-item>
  </el-form>
</template>

<script>
import MixFormRule from "@/components/mixins/formRule";
import MixCreativeForm from "@/components/mixins/creativeForm";
const { SPINNER } = CONSTANT.CREATIVE_DEFAULT_VALUE;
export default {
  data() {
    return {
      tab: "top",
      item: {
        top: {
          landing_page: "",
          click_tracking: "",
          images: [...Array(SPINNER.IMAGE.MIN_NUM)].map(() =>
            _.cloneDeep(SPINNER.IMAGE.ITEM)
          ),
        },
        bottom: {
          landing_page: "",
          click_tracking: "",
          images: [...Array(SPINNER.IMAGE.MIN_NUM)].map(() =>
            _.cloneDeep(SPINNER.IMAGE.ITEM)
          ),
        },
        left: {
          landing_page: "",
          click_tracking: "",
          images: [...Array(SPINNER.IMAGE.MIN_NUM)].map(() =>
            _.cloneDeep(SPINNER.IMAGE.ITEM)
          ),
        },
        right: {
          landing_page: "",
          click_tracking: "",
          images: [...Array(SPINNER.IMAGE.MIN_NUM)].map(() =>
            _.cloneDeep(SPINNER.IMAGE.ITEM)
          ),
        },
        offset_bottom: {
          number: "",
          unit: "px",
        },
      },
      limited_size: {
        image: {
          width: {
            max: 630,
            min: 630,
          },
          height: {
            max: 630,
            min: 630,
          },
        },
      },
    };
  },
  mixins: [MixFormRule, MixCreativeForm],
  methods: {
    setData(row) {
      _.forEach(["top", "left", "right", "bottom"], (key) => {
        this.item[key].landing_page = decodeURI(row[key].landing_page);
        this.item[key].click_tracking = decodeURI(row[key].click_tracking);
        this.item[key].images = _.map(row[key].images, (image) => {
          return {
            url: decodeURI(image.url),
            use_shake_center: image.use_shake_center,
            shake_center: {
              x: image.shake_center ? image.shake_center.x : 0,
              y: image.shake_center ? image.shake_center.y : 0,
            },
          };
        });
      });
      this.item.offset_bottom.unit = row.offset_bottom_unit;
      this.item.offset_bottom.number = row.offset_bottom_number;
    },
    async getData(setObj) {
      _.forEach(["top", "left", "right", "bottom"], (key) => {
        setObj[key] = {};
        setObj[key].landing_page = this.item[key].landing_page.replace(/[^\x00-\x7F]/g, (c) => encodeURI(c));
        setObj[key].click_tracking = this.item[key].click_tracking.replace(/[^\x00-\x7F]/g, (c) => encodeURI(c));
        setObj[key].images = _.map(this.item[key].images, (image) => {
          let obj = {
            url: image.url.replace(/[^\x00-\x7F]/g, (c) => encodeURI(c)),
            use_shake_center: image.use_shake_center,
          };
          if (image.use_shake_center) {
            obj.shake_center = {
              x: image.shake_center.x,
              y: image.shake_center.y,
            };
          }
          return obj;
        });
      });
      setObj.offset_bottom_unit = this.item.offset_bottom.unit;
      setObj.offset_bottom_number = this.item.offset_bottom.number;
      return setObj;
    },
  },
};
</script>

<style></style>
